import { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { attemptToJoinExam, finishExam, getSchoolName, leaveExam } from "../../assets/api/userActions";
import Swal from 'sweetalert2';

import CountDown from "../../components/countDown/countDown";
// import dummy from "./dummy.pdf";
import TestAnswerOptions from '../../components/testAnswerOptions';
import QuizQuestionFileViewer from '../../components/quizQuestionFileViewer/QuizQuestionFileViewer';
import { buildPdfStreamUrl } from '../../assets/utils/pdfViewerUrl';
import { getQuizQuestionDownloadLabel } from '../../assets/utils/quizQuestionFile';
// import TestQuestion from '../../components/testQuestion';


import { ReactComponent as Exit } from '../../assets/icons/exit.svg';
import { ReactComponent as Refresh } from '../../assets/icons/RightSquare.svg';

import classes from '../../App.module.scss';
import { checkMatchQuestion, safeParseLocalStorageJson } from "../../assets/utils/utils";
import Loading from "../../components/loading/loading";
import { useLeaveExamOnTabClose } from "../../hooks/useLeaveExamOnTabClose";
import { showExamExitConfirmSwal } from '../../assets/utils/examExitConfirmSwal';

function TestExam() {

    const navigate = useNavigate();
    const params = useParams();

    const [examDataAttempt, setExamDataAttempt] = useState([]);
    const [userAnswered, setUserAnswered] = useState()
    const [examData, setExamData] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [timeLeft, setTimeLeft] = useState(0);
    const [totalTime, setTotalTime] = useState(0);
    const [answered, setAnswered] = useState();
    const [schoolName, setSchoolName] = useState("");
    const [unAnswered, setUnAnswered] = useState();
    const fetchInProgress = useRef(false);
    const storedUser = safeParseLocalStorageJson("userToken");
    // const [pages, setPages] = useState(null);
    // const [pageNumber, setPageNumber] = useState(1);


    const fetchSchoolName = useCallback(async () => {
        await getSchoolName(params.quiz).then((res) => setSchoolName(res.schoolName));
    }, [params.quiz]);

    const onFinishHandler = async (e) => {
        const res = await finishExam(e);
        if (res?.status === 'success-finish') {
            navigate('/quiz/finish');
            return;
        }
        throw new Error(res?.message || 'امکان اتمام آزمون نیست');
    };

    const onLeaveHandler = async (e) => {
        const res = await leaveExam(e);
        if (res?.status === 'success-leave') {
            navigate('/quiz/join/' + params.quiz);
            return;
        }
        throw new Error(res?.message || 'امکان ترک آزمون نیست');
    };

    const showExitConfirm = (leave) => {
        const isLeaveExam = !!leave;
        showExamExitConfirmSwal({
            isLeaveExam,
            unansweredCount: isLeaveExam ? 0 : unAnswered,
            onConfirm: async () => {
                if (isLeaveExam) await onLeaveHandler(examDataAttempt.id);
                else await onFinishHandler(examDataAttempt.id);
            },
        });
    };


    const fetchData = useCallback(async () => {
        const data = await attemptToJoinExam(params.quiz);
        if (data?.status === "attempt-finished") {
            navigate('/quiz/finish');
            return;
        }
        if (data?.status !== "joined") {
            let a = data?.message;
            a = a.split("{").join("");
            a = a.split("}").join("");
            if (a.includes("date")) {
                a = a.replace("date", data?.date);
            }
            if (a.includes("time")) {
                a = a.replace("time", data?.time);
            }
            Swal.fire({
                icon: "error",
                title: `${a}`,
            });
            navigate("/quiz/join/" + params.quiz);
            return;
        }

        setExamData(data);
        data.attempt.answers && setUserAnswered(checkMatchQuestion(data.quiz, data.attempt));
        setExamDataAttempt(data.attempt);
        setTimeLeft(data.attempt.timer);
        setTotalTime(data.attempt.total_time);
        setIsLoading(false);
        setAnswered(data.attempt.answered_questions);
        setUnAnswered(data.attempt.unanswered_questions);
        return data.quiz.title;
    }, [params.quiz, navigate]);

    const answerResHandler = (attemptPayload) => {
        if (!attemptPayload) return;
        setAnswered(attemptPayload.answered_questions);
        setUnAnswered(attemptPayload.unanswered_questions);
        setExamDataAttempt((prev) => (prev ? { ...prev, ...attemptPayload } : attemptPayload));
        setExamData((prev) => {
            if (!prev?.quiz) return prev;
            const mergedAttempt = { ...(prev.attempt || {}), ...attemptPayload };
            setUserAnswered(checkMatchQuestion(prev.quiz, mergedAttempt));
            return { ...prev, attempt: mergedAttempt };
        });
    };

    const isInThePast = useCallback((date) => {
        const today = new Date();
        return date < today;
    }, []);

    const toLoginPage = useCallback(() => {
        localStorage.removeItem("userToken");
        navigate(`/quiz/join/${params.quiz}`);
    }, [navigate, params.quiz]);

    useLeaveExamOnTabClose(examData?.quiz?.leave, examDataAttempt?.id);
    useEffect(() => {
        document.title = "شروع آزمون";
        const LSdata = safeParseLocalStorageJson("userToken");
        if (!LSdata) {
            navigate(`/quiz/join/${params.quiz}`);
            return;
        }
        if (LSdata && isInThePast(LSdata.expireDate)) {
            toLoginPage();
            return;
        }
        if (fetchInProgress.current) return;
        fetchInProgress.current = true;
        const examTitlePromise = fetchData();
        fetchSchoolName();
        examTitlePromise.finally(() => {
            fetchInProgress.current = false;
        });
        examTitlePromise.then((res) => res && (document.title = `آزمون ${res}`));
    }, [params.quiz, navigate, fetchData, fetchSchoolName, toLoginPage, isInThePast]);

    return (
        <div className={`${classes.appContainer} ${classes.examAppContainer}`} >
            {
                !isLoading ?

                    examData &&
                    <div className={classes.container}>
                        <header className={classes.timeRemainedContainer} style={{ display: 'grid' }}>
                            <div className={classes.headerBox}>
                                <div className={classes.buttonContainer}>
                                    <p className={classes.finishExamBtn} onClick={() => showExitConfirm(false)}>اتمام آزمون</p>
                                    {examData.quiz.leave ? (
                                        <p className={classes.leaveExamBtn} onClick={() => showExitConfirm(true)}>ترک آزمون</p>
                                    ) : null}
                                </div>
                                {timeLeft !== "unlimited" ? <CountDown totalTime={totalTime} timeRemained={timeLeft} attemptID={examDataAttempt?.id} /> : <p className={classes.unlimited_text}>زمان باقیمانده : نامحدود</p>}


                                {/* <div className='time-remained'>4:20:00</div> */}
                            </div>
                            <div className={classes.informationBar}>
                                <div className={classes.examDetails}>
                                    <div className={classes.examDetailsTitle}>
                                        <h1>{examData.quiz.title}</h1>
                                        <p>{`(${schoolName})`}</p>
                                    </div>
                                    <div id={classes.returnBtn}>
                                        <p>بازگشت به سایت</p>
                                        <div className={classes.exitIcon}>
                                            <Exit fill='#fff' width="15px" height='15px' />
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.personalDetails}>
                                    <ul>
                                        <li>{`نام کاربر : ${storedUser?.name ?? ""}`}</li>
                                        <li>{`مدت آزمون : ${examData?.quiz?.duration ? examData?.quiz?.duration + " دقیقه " : "نامحدود"}`}</li>
                                        <li>{`نوع آزمون : ${examData.quiz.type === "test" ? "تستی" : "تشریحی"}`}</li>
                                        {
                                            examData.quiz.test_type === "score" ?
                                                <li>{`نمره کل : ${examData.quiz.total_score}`}</li>
                                                : <li>{`ضریب منفی : ${examData.quiz.negative_point === null ? "ندارد" : examData.quiz.negative_point?.replace("/", " به ")}`}</li>
                                        }
                                        <li>{`تعداد سوالات : ${examData.quiz.number_of_question}`}</li>
                                    </ul>
                                </div>
                            </div>
                        </header>

                        <main className={classes.mainContainer}>
                            <div className={classes.answerSheetContainer}>
                                <div className={classes.answerSheetHeader}>
                                    <h3>پاسخنامه</h3>
                                    <div className={classes.answerDatasheet}>
                                        <p className={classes.answerDatasheet_answer}>{`پاسخ داده شده : ${answered === null ? 0 : answered}`}</p>
                                        <p className={classes.answerDatasheet_notAnswer}>{`پاسخ داده نشده : ${unAnswered === null ? 0 : unAnswered}`}</p>
                                    </div>
                                </div>
                                <div className={classes.answerSheet}>
                                    <ol>
                                        {
                                            examData.quiz?.questions?.map((data, index) => (
                                                <TestAnswerOptions
                                                    key={data.id}
                                                    id={data.id}
                                                    attemptID={examDataAttempt.id}
                                                    examDataAttempt={examDataAttempt}
                                                    userAnswered={userAnswered}
                                                    isRank={examData.quiz.test_type}
                                                    quizType={examData.quiz.type}
                                                    answerResHandler={answerResHandler}
                                                    options={data.options}
                                                    score={data.score}
                                                    displayQuNo={data.question_number ?? index + 1}
                                                />
                                            ))
                                        }
                                    </ol>
                                </div>
                            </div>
                            {/* DISPLAY QUESTION / QUESTION SECTION  */}
                            <section className={classes.questionSection}>
                                <div className={classes.questionSection_header}>
                                    <h2>سوالات آزمون</h2>
                                    <div style={{ display: "flex", gap: "10px" }}>
                                        {/* دکمه دانلود PDF */}
                                        <a
                                            href={buildPdfStreamUrl(examData?.quiz?.question_pdf)}
                                            download
                                            className={classes.reloadBtn}
                                            style={{ display: "flex", alignItems: "center", cursor: "pointer", textDecoration: "none" }}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <p style={{ margin: 0 }}>
                                                {getQuizQuestionDownloadLabel(
                                                    examData?.quiz?.question_file_extension || examData?.quiz?.question_pdf,
                                                )}
                                            </p>
                                            <div id={classes.refreshIcon} style={{ marginRight: "4px" }}>
                                                {/* آیکون دانلود */}
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                                    <polyline points="7 10 12 15 17 10"></polyline>
                                                    <line x1="12" y1="15" x2="12" y2="3"></line>
                                                </svg>
                                            </div>
                                        </a>
                                        {/* دکمه بارگذاری مجدد */}
                                        <div className={classes.reloadBtn} onClick={() => window.location.reload()}>
                                            <p>بارگذاری مجدد</p>
                                            <div id={classes.refreshIcon}>
                                                <Refresh />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.questionContainer}>
                                    <QuizQuestionFileViewer
                                        fileUrl={examData?.quiz?.question_pdf}
                                        downloadUrl={examData?.quiz?.question_pdf}
                                        fileExtension={examData?.quiz?.question_file_extension}
                                    />
                                </div>
                            </section>

                        </main>
                    </div> :
                    <>
                        <Loading />
                    </>
            }
        </div>
    );
}

export default TestExam;
